import { createContext, useContext } from 'react';
import type { AssetItem } from '../features/workspace/assetmodel';

interface FileViewerContextValue {
  getFile: (tabId: string) => AssetItem | undefined;
  /** ids of every file-view tab currently open in the nav bar — lets BodyContent
   * keep all of them mounted (hidden) instead of just the active one. */
  openFileViewTabIds: string[];
}

export const FileViewerContext = createContext<FileViewerContextValue>({
  getFile: () => undefined,
  openFileViewTabIds: [],
});

export const useFileViewerContext = () => useContext(FileViewerContext);
